// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import {
  Loading,
  MessageBox,
  Message,
  Notification
} from 'element-ui'
import App from './App'
import router from '@/router'
import axios from 'axios'
import qs from 'qs'

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.config.productionTip = false

/* eslint-disable no-new */
//配置axios
axios.interceptors.request.use(config => {    // 这里的config包含每次请求的内容
		let token = sessionStorage.getItem('token');
    if (token != null) {
        config.headers['x-auth-token'] = token;
    }
    return config;
}, function (err) {
    return Promise.reject(err);
});

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js